"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function ProxiesAgentsGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 17",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M3.721 4.814c0-.22.179-.4.4-.4h1.704a.4.4 0 110 .8H4.121a.4.4 0 01-.4-.4zM3.721 6.698c0-.22.179-.4.4-.4h2.71a.4.4 0 010 .8H4.12a.4.4 0 01-.4-.4zM6.82 13.01a.48.48 0 100-.96.48.48 0 000 .96zm0 .8a1.28 1.28 0 100-2.56 1.28 1.28 0 000 2.56z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M11.638 7.206v7.4a1.4 1.4 0 01-1.4 1.4H3.4a1.4 1.4 0 01-1.4-1.4V3.376a1.4 1.4 0 011.4-1.4h4.077a3.621 3.621 0 114.16 5.23zm1.834-3.485a2.821 2.821 0 11-5.642 0 2.821 2.821 0 015.642 0zm-2.634 3.616a3.621 3.621 0 01-3.684-4.562H3.4a.6.6 0 00-.6.6v11.23a.6.6 0 00.6.6h6.838a.6.6 0 00.6-.6V7.338z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M11.656 3.7a1 1 0 11-2 0 1 1 0 012 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    fillRule: "evenodd",
    d: "M3.621 4.814a.5.5 0 01.5-.5h1.704a.5.5 0 010 1H4.121a.5.5 0 01-.5-.5zm0 1.884a.5.5 0 01.5-.5h2.71a.5.5 0 110 1H4.12a.5.5 0 01-.5-.5zm3.198 6.211a.38.38 0 100-.758.38.38 0 000 .758zm1.38-.379a1.38 1.38 0 11-2.76 0 1.38 1.38 0 012.76 0zm2.452-6.088a2.721 2.721 0 100-5.442 2.721 2.721 0 000 5.442zm.087 1a3.721 3.721 0 01-3.712-4.566H3.4a.5.5 0 00-.5.5v11.23a.5.5 0 00.5.5h6.838a.5.5 0 00.5-.5V7.44zm0-.101l-.087.001a3.621 3.621 0 01-3.497-4.566H3.4a.6.6 0 00-.6.6v11.23a.6.6 0 00.6.6h6.838a.6.6 0 00.6-.6V7.337a3.666 3.666 0 01-.1.004zm1-.06v7.325a1.5 1.5 0 01-1.5 1.5H3.4a1.5 1.5 0 01-1.5-1.5V3.376a1.5 1.5 0 011.5-1.5h4.019a3.721 3.721 0 114.32 5.405zm-.1-.075v7.4a1.4 1.4 0 01-1.4 1.4H3.4a1.4 1.4 0 01-1.4-1.4V3.376a1.4 1.4 0 011.4-1.4h4.078a3.621 3.621 0 114.16 5.23zm.118-3.507a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zm1.716.022a2.821 2.821 0 11-5.642 0 2.821 2.821 0 015.642 0zM3.72 4.814c0-.22.18-.4.4-.4h1.704a.4.4 0 010 .8H4.121a.4.4 0 01-.4-.4zm0 1.884c0-.22.18-.4.4-.4h2.71a.4.4 0 110 .8H4.12a.4.4 0 01-.4-.4zm3.577 5.832a.48.48 0 11-.958 0 .48.48 0 01.958 0zm.8 0a1.28 1.28 0 11-2.558 0 1.28 1.28 0 012.558 0zm2.558-7.83a1 1 0 100-2 1 1 0 000 2z",
    clipRule: "evenodd"
  }));
}

ProxiesAgentsGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
ProxiesAgentsGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = ProxiesAgentsGreyOutline;
exports["default"] = _default;